import { jsx } from "react/jsx-runtime";
import { lightThemeClass, darkThemeClass } from "./theme.js";
function LightTheme({
  className,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx("div", {
    className: lightThemeClass + (className ? ` ${className}` : ""),
    ...props,
    children
  });
}
function DarkTheme({
  className,
  children,
  ...props
}) {
  return /* @__PURE__ */ jsx("div", {
    className: darkThemeClass + (className ? ` ${className}` : ""),
    ...props,
    children
  });
}
export {
  DarkTheme,
  LightTheme
};
//# sourceMappingURL=themeContainers.js.map
